/**
 * Kontoverbindungen
 * API für Kontoverbindungen
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


export type KontoverbindungStatusEnumDto = 'SET' | 'NOTSET' | 'DIVERGES_FROM_STANDARD';

export const KontoverbindungStatusEnumDto = {
SET: 'SET' as KontoverbindungStatusEnumDto,
NOTSET: 'NOTSET' as KontoverbindungStatusEnumDto,
DIVERGES_FROM_STANDARD: 'DIVERGES_FROM_STANDARD' as KontoverbindungStatusEnumDto
};
import {Validators, FormControl} from "@angular/forms";
import {OpenApiValidators} from "../validators";

export const KontoverbindungStatusEnumDtoValidator = OpenApiValidators.enumValidator(KontoverbindungStatusEnumDto);
